import React from 'react';
import Button from './ui/button/Button.jsx';
import Configurator from './Configurator.jsx';
import baseConfStyles from './Configurator.styl';
import styles from './EnclosureOrderConfigurator.styl';
import Accordion from "./ui/features/Accordion.jsx";
import Switch from "./ui/features/InputSwitch.jsx";
import Modal from "./ui/features/ModalForm.jsx";
import jQuery from "jquery";
import Popup from "./ui/features/Popup/Popup.jsx";
import Image from './ui/features/Image.jsx';

const specItem =
	{
		label: 'Конфигурация шкафа №',
		content: [
			{name: 'Тип монтажа:*' ,selected:'-'},
			{name: 'Высота U:*',selected:'-'},
			{name: 'Ширина:*',selected:'-'},
			{name: 'Глубина:*',selected:'-'},
			{name: 'Полезная глубина:',selected:'-'},
			{name: 'Статическая нагрузка:*',selected:'-'},
			{name: 'Кол-во дверей шкафа:',selected:'-'},
			{name: 'Тип передней двери:*',selected:'-'},
			{name: 'Тип задней двери:*',selected:'-'},
			{name: 'Антивандальное исполнение:',selected:'Нет'},
			{name: 'Угол открытия двери:',selected:'-'},
			{name: 'Цвет:',selected:'-'},
			{name: 'Номер цвета RAL:*',selected:'-'},
			{name: 'Степень защиты - IP:*',selected:'-'},
			{name: 'Климатическое исполнение:*',selected:'-'},
			{name: 'Дополнительная комплектация:*',selected:'Нет'},
			{name: 'Опоры регулируемые:',selected:'Нет'},
			{name: 'Шина заземления ER-12-325-M1:',selected:'Нет'},
			{name: 'Щеточные ввода (BE05/35-390-115M):',selected:'Нет'},
			{name: 'Вентиляционная панель:',selected:'Нет'},
			{name: 'Ролики с тормозом:' ,selected:'Нет'},
			{name: 'Кронштейны для установки вертикальных ПДУ и органайзеров:',selected:'Нет'},
			{name: 'Количество шкафов:*',selected:1},
			{name: 'Дополнительные требования:',selected:''},
		]
	};
const filterList = [
	{name: 'Тип монтажа:*' ,values: ['Выбрать','Настенный','Напольный'] ,selected:'-',type:'select'},
	{name: 'Высота U:*',values: [] ,selected:'-',type:'select'},
	{name: 'Ширина:*',values: [] ,selected:'-',type:'select'},
	{name: 'Глубина:*',values: [] ,selected:'-',type:'select'},
	{name: 'Полезная глубина:',values: [] ,selected:'-',type:'select'},
	{name: 'Статическая нагрузка:*',values: [],selected:'-',type:'select'},
	{name: 'Кол-во дверей шкафа:',values: [] ,selected:'-',type:'select'},
	{name: 'Тип передней двери:*',values:[] ,selected:'-',type:'select'},
	{name: 'Тип задней двери:*',values: [] ,selected:'-',type:'select'},
	{name: 'Антивандальное исполнение:',values:[],selected:false,type:'switch'},
	{name: 'Угол открытия двери:',values:[] ,selected:'-',type:'select'},
	{name: 'Цвет:',values:[] ,selected:'-',type:'select'},
	{name: 'Номер цвета RAL:*',values: [],selected:'-',type:'select'},
	{name: 'Степень защиты - IP:*',values: [] ,selected:'-',type:'select'},
	{name: 'Климатическое исполнение:*',values: [],selected:'-',type:'select'},
	{name: 'Дополнительная комплектация:*',values:[] ,selected:false,type:'switch'},
	{name: 'Опоры регулируемые:',values: [],selected:false,type:'switch'},
	{name: 'Шина заземления ER-12-325-M1:',values:[] ,selected:false,type:'switch'},
	{name: 'Щеточные ввода (BE05/35-390-115M):',values:[] ,selected:false,type:'switch'},
	{name: 'Вентиляционная панель:',values: [],selected:false,type:'switch'},
	{name: 'Ролики с тормозом:',values:[] ,selected:false,type:'switch'},
	{name: 'Кронштейны для установки вертикальных ПДУ и органайзеров:',values:[],selected:false,type:'switch'},
	{name: 'Количество шкафов',values:[],selected:1,type:'input'},
	{name: 'Дополнительные требования:',values: [],selected:'',type:'textArea'},
	]
/**
 * Конфигуратор аксессуаров для шкафов
 */
class EnclosureOrderConfigurator extends Configurator
{
	constructor(props) {
		super(props);

		this.state = {
			specList:[],
			filterList,
			contacts:{
				FIO:'',
				phone:'',
				email:''
			},
			readiness: false,
			openModal: false,
			tabType: 'select', //custom, select
			activeTab: 0,

		};

		this.onSwitchConfigurator     = this.onSwitchConfigurator.bind(this);
		this.onBtnExcelClick          = this.onBtnExcelClick.bind(this);
		this.onFilterChange           = this.onFilterChange.bind(this)
		this.openModalForm            = this.openModalForm.bind(this)
		this.activateTab              = this.activateTab.bind(this)
		this.sendToEmail              =this.sendToEmail.bind(this)
		this.onContactsChange         =this.onContactsChange.bind(this)
		this.addToList                = this.addToList.bind(this)
		this.clearFilter              = this.clearFilter.bind(this)
		this.closeWarning             =this.closeWarning.bind(this)

	}

	getType() {
		return 'enclosure_order';
	}

	getCustomStyles() {
		return styles;
	}
	componentDidMount() {
		this.addToList()
	}

	onSwitchConfigurator() {
			this.props.onSwitchConfigurator();
	}
	onClickCustom(){
		let arr=[1,2,3,4,5,10,11,12,13,14]
		let newFilterList=this.state.filterList.map((i,id)=>{
			if(arr.includes(id)){
				i.type='input'
			}
			return i
		})
		this.setState({filterList:newFilterList, tabType:'custom'})
	}
	onClickSelect(){
		let arr=[1,2,3,4,5,10,11,12,13,14]
		let newFilterList=this.state.filterList.map((i,id)=>{
			if(arr.includes(id)){
				i.type='select'
			}
			return i
		})
		this.setState({filterList:newFilterList, tabType:'select'})
	}

	doPrint(params) {
		let _params = params || {};
		_params.data = {
			specList: JSON.stringify(this.state.specList)
		};
		super.doPrint(_params);
	}


	onBtnExcelClick() {
		this.doPrint({format: 'xls'});
	}
	openModalForm(){
		let specList=this.state.specList
	if(specList.every(item=>{
		let filter=item.content.filter(elem=>elem.name.includes('*'))
		return filter.every(i=>{
			return (i.selected!=='-'||i.selected===true)
	})})){
		this.setState(prev=>{
				return{openModal: !prev.openModal}
			}
		)
	}else {
		this.showWarning('Для продолжения заполните все обязательные поля(*).')
	}
	}
onContactsChange(value,mark){
		this.setState(prev=>{
			let contacts={...prev.contacts}
			contacts[mark]=value
			return{contacts}
		})
}

	sendToEmail(){
		  let contacts=this.state.contacts
		if(contacts.FIO.length===0||contacts.phone.length===0||contacts.email.length===0){
			this.showWarning('Для продолжения заполните свои контактные данные.')
		}else if (!contacts.email.includes('@')){
			this.showWarning('Поле \'email\' должно содержать символ \'@\'')
		}else {
			jQuery.post(
				'itkcfg.php',
				{
					type: 'enclosure_order',
					action: 'postForm',
					data: {
						specList: this.state.specList,
						contacts: this.state.contacts
					}
				}
			);
			this.setState({openModal: false})

			alert('Благодарим за заказ! Наши сотрудники свяжутся с вами в ближайшее время.');
		}
	}

	onFilterChange(id,value) {
		let wall=[['Выбрать',6,9,12,15,18,20,22],['Выбрать',550,600],['Выбрать',350,450,600,650]
			,['Выбрать',250,350,400,500,600],['Выбрать',50,90,120],['Выбрать',1],['Выбрать','Стеклянная', 'Глухая металлическая', 'Перфорированная металлическая'] ,
			['Выбрать','Нет'],[],['Выбрать','110°', '200°'],
			['Выбрать','Серый', 'Черный'] ,['Выбрать','7035', '9005'],['Выбрать','IP00', 'IP20','IP43','IP54'] ,['Выбрать','УХЛ1', 'УЗ']]
		let floor=[['Выбрать',24,28,33,38,42,47],['Выбрать',600,750,800],['Выбрать',400,600,800,1000,1100]
			,['Выбрать',315,515,715,915,1015],['Выбрать',700,1000],['Выбрать',2],['Выбрать','Стеклянная', 'Глухая металлическая', 'Перфорированная одностворчатая','Перфорированная двустворчатая'] ,
			['Выбрать','Стенка с кабельными вводами','Глухая металлическая', 'Перфорированная одностворчатая','Перфорированная двустворчатая'],[],['Выбрать','120°'],
			['Выбрать','Серый', 'Черный'] ,['Выбрать','7035', '9005'],['Выбрать','IP00', 'IP20','IP54'] ,['Выбрать','УХЛ1', 'УЗ']]
		this.setState(prev=>{
			let filterList=[...prev.filterList]
			if(id==0){
				if(value=='Напольный'){
					floor.map((i,index)=>{
						filterList[index+1].values=i
					})
				}else if(value=='Настенный'){
					wall.map((i,index)=>{
						filterList[index+1].values=i
					})
				}else {
					filterList=filterList.map((i,index)=>{
						if(index!==0){
							i.values=[]
						}
						return i
					})
				}
			}
			if(typeof filterList[id].selected=='boolean'){
				filterList[id].selected=!prev.filterList[id].selected
				return{filterList}
			}
			if(id==11){
				if(filterList[id+1].type=='select'){
					filterList[id+1].selected=value=='Серый'?'7035':value=='Черный'?'9005':'-'
				}
			}
			if(id==12){
				if(filterList[id-1].type=='select') {
					filterList[id - 1].selected = value == '7035' ? 'Серый' : value == '9005' ? 'Черный' : '-'
				}
			}

			filterList[id].selected=value=='Выбрать'?'-':value
			return {filterList}
		},()=>this.onListChange(this.state.filterList))

	}
	onListChange(filterList){
		this.setState(prev=>{
			let specList=[...prev.specList]
			let activeTab=prev.activeTab
			filterList.map((i,index)=>{
				if(typeof i.selected =='boolean'){
					if(i.selected==true){
						specList[activeTab].content[index].selected='Да'
					}else {
						specList[activeTab].content[index].selected='Нет'
					}
				}else{
					specList[activeTab].content[index].selected=i.selected
				}
			})
			return{specList}
		})
	}
	addToList(){
		let specList=this.state.specList
		if(specList.every(item=>{
			let filter=item.content.filter(elem=>elem.name.includes('*'))
			return filter.every(i=>{
				return (i.selected!=='-'||i.selected===true)
			})})){
			this.setState(prev=>{
				let specList=[...prev.specList]
				let newSpecItem = JSON.parse(JSON.stringify(specItem))
				newSpecItem.label='Конфигурация шкафа №'+(+specList.length+1)
				specList.push(newSpecItem)
				return{specList}
			},()=>this.activateTab(this.state.specList.length-1))
		}else {
			this.showWarning('Для продолжения заполните все обязательные поля(*).')
		}

	}
	clearFilter(){
		this.setState(prev=>{
			let filterList=[...prev.filterList]
			filterList=filterList.map((i,id)=>{
				if(typeof i.selected=='boolean'){
					i.selected=false
				}else {
					i.selected=id===22?1:id===23?'':'-'
				}
				return i
			})
			return{filterList}
		},()=>this.onFilterChange(0,'-'))
	}

	activateTab(activeTab){
		 this.setState(prev=>{
			 let filterList=[...prev.filterList]
			 let specList=[...prev.specList]
			 filterList=filterList.map((i,index)=>{
				 if(typeof i.selected =='boolean'){
					 if(specList[activeTab].content[index].selected=='Да'){
						 i.selected=true
					 }else {
						 i.selected=false
					 }
				 }else{
					 i.selected=specList[activeTab].content[index].selected
				 }
				 return i
			 })
			 return{activeTab,filterList}},()=>this.onFilterChange(0,this.state.filterList[0].selected))
	}

	showWarning(warningText){
		this.setState({
			warningText
		}, ()=>{
			document.location.href = document.location.href.split('#')[0] + '#warning'
		})
	}

	clickAwayHandler(event){
		if(event.target.id && event.target.id === 'warning'){
			this.closeWarning()
		}
	}

	closeWarning(){
		this.setState({
		warningText:''
	}, ()=>{
		document.location.href = document.location.href.split('#')[0]+'#'
	})
	}


	render() {
		let firstLableStyle = ''
		let secondLableStyle = ''
		if(this.state.tabType === 'select'){
			firstLableStyle = '#fff'
			secondLableStyle = '#E6EFF1'
		}else if(this.state.tabType === 'custom'){
			firstLableStyle = '#E6EFF1'
			secondLableStyle = '#fff'
		}

		return (
			<div className={styles.cfg}>
				{/* Лого */}
				<Image
					className={styles.logo}
					blockChangeScale={true}
				/>
				{/* Заголовок конфигуратора */}
				<span className={styles.title}>Конфигуратор заказных шкафов</span>
				<div className={styles.background}></div>
				{this.state.warningText &&<Popup
					warningText={this.state.warningText}
					onClick={this.closeWarning}
				type={'itk'}/>
				}
				{this.state.openModal&&
				<Modal sendToEmail={this.sendToEmail} toggleModal={this.openModalForm} onChange={this.onContactsChange}/>}
				<div style={{position: 'absolute', top: '80px', left: "25px", zIndex:'20'}}>
        	<span
						onClick={()=>this.onClickSelect()}
						style={{background: firstLableStyle}}
						className={styles.cableSectionTitle + ' ' + 'activeTab'}>Выбор по параметрам</span>
					<span
                        onClick={()=>this.onClickCustom()}
						style={{background: secondLableStyle}}
						className={styles.koaksCableTitle + ' ' + 'activeTab'}>Ввести свои значения</span>
				</div>

				<div className={styles.accordionContainer}>
					<Accordion panels={this.state.specList} activateTab={this.activateTab} activeTab={this.state.activeTab}/>
				</div>
				<div className={styles.filterContainer}>
					{this.state.filterList.map((i,id,arr)=>{

						if(i.type=='select'){
							let disabled
							if(id===0){
								disabled=false
							}else {
								if(arr[0].selected==='-'){
									disabled=true
								}else {
									disabled=false
								}
							}
							return(<div className={styles.filterSelectContainer} key={id+'filter'}>
								<span>{i.name}</span>
								<select className={styles.filterSelect} value={i.selected} onChange={(e)=>this.onFilterChange(id,e.target.value)} disabled={disabled}>
									{i.values.length>0?i.values.map(item=>{
										return(<option value={item} key={id+item}>{item}</option>)
									}):<option value="Выбрать">Выбрать</option>}</select>
							</div>)
						}
						if(i.type=='switch'){
							return(<div className={styles.filterSwitchContainer} key={id+'filter'}>
								<span>{i.name}</span>
								<Switch type='itk' value={i.selected} id={id} onChange={this.onFilterChange}/>
							</div>)
						}
						if(i.type=='input'){
							let type='number'
							let styl={}
							let disabled
							if(arr[0].selected==='-'){
								disabled=true
							}else {
								disabled=false
							}
							if(id==11||id==13||id==14){
								type='text'
							}

							return(
								<React.Fragment>
									<div className={styles.filterInputContainer} key={id+'filter'}>
										<span>{i.name}</span>
										<input className={styles.filterInput} disabled={disabled} style={styl} type={type} min={1}
													 defaultValue={i.selected} onBlur={(e)=>this.onFilterChange(id,e.target.value)}/>
									</div>
									{id===22?<div></div>:null}
								</React.Fragment>
							)
						}

						if(i.type=='textArea'){
							return	(
							<div className={styles.filterAreaContainer} key={id+'filter'}>
								<textarea className={styles.filterArea} value={i.selected} placeholder={'Введите дополнительные требования'} onChange={(e)=>this.onFilterChange(id,e.target.value)}></textarea>
							</div>)
						}
					})}

				</div>
				<button style={{position:'absolute',zIndex:'20',left:'50px', top:'680px'}} onClick={()=>this.clearFilter()}>Сбросить параметры</button>


				{/* Перейти к подбору шкафов по параметрам */}
				<Button
					buttonStyle={styles.btnSwitchToEnclosureConf}
					iconStyle={styles.btnSwitchToEnclosureConfIcon}
					textStyle={styles.btnSwitchToEnclosureConfText}
					text="Перейти к подбору шкафов по параметрам"
					onClick={this.onSwitchConfigurator}
				/>

				<Button
					buttonStyle={styles.btnAddEnclosureConf}
					iconStyle={styles.btnAddEnclosureConfIcon}
					textStyle={styles.btnAddEnclosureConfText}
					text="Добавить шкаф с новой конфигурацией"
					onClick={this.addToList}
				/>

				{/* Сохранить в спецификацию */}
				<Button
					buttonStyle={styles.btnSaveSpec}
					buttonDisabledStyle={styles.btnSaveSpecDisabled}
					iconStyle={styles.btnSaveSpecIcon}
					textStyle={styles.btnSaveSpecText}
					text="Отправить заявку"
					disabled={this.state.readiness}
					onClick={this.openModalForm}
				/>


				{/* Сохранить в PDF */}
				<Button
					buttonStyle={styles.btnPdf}
					buttonDisabledStyle={styles.btnPdfDisabled}
					iconStyle={baseConfStyles.btnPdfIcon}
					text="Сохранить в PDF"
					onClick={this.onBtnPrintPdfClick}
				/>

				{/* Скачать в EXCEL */}
				<Button
					buttonStyle={styles.btnExcel}
					buttonDisabledStyle={styles.btnExcelDisabled}
					iconStyle={styles.btnExcelIcon}
					text="Скачать в EXCEL"
					onClick={this.onBtnExcelClick}
				/>

				{/* Распечатать */}
				<Button
					buttonStyle={styles.btnPrint}
					buttonDisabledStyle={styles.btnPrintDisabled}
					iconStyle={baseConfStyles.btnPrintIcon}
					text="Распечатать"
					onClick={this.onBtnPrintClick}
				/>
				<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '50%', height: '22px', top: '785px'}}/>
				<a className={styles.homeLink} href={'https://www.itk-group.ru/'} target="_blank">На основной сайт ITK</a>

				{/* Техническая поддержка */}
				<div style={{
					position: 'absolute',
					backgroundColor: '#76d750',
					width: '50%',
					height: '22px',
					top: '785px',
					left: '513px'
				}}/>
				<a style={{
					position: 'absolute',
					top: '789px',
					left: '250px',
					color: '#37424a',
					width: '141px',
					height: '14px'
				}} href={'https://www.itk-group.ru/servis-i-podderzhka/'} target="_blank">Техническая поддержка:
				</a>
				<span className={styles.techSupport}>+7 (495) 542-22-24</span>
			</div>
		);
	}
}





export default EnclosureOrderConfigurator;



// WEBPACK FOOTER //
// ./src/react/EnclosureOrderConfigurator.jsx